import { Component, Input } from '@angular/core';
import { isNullOrUndefined } from 'src/app/common/utils/object.extensions';
import {
  PlaceAdditionalData,
  VisitorPlace,
} from 'src/app/modules/shared/models/visitor.place';

@Component({
  selector: 'ig-dine-icons',
  templateUrl: './dine.icons.component.html',
  styleUrls: ['./dine.icons.component.scss'],
})
export class DineIconsComponent {
  @Input() public place: PlaceAdditionalData;
  @Input() size = 62;
  @Input() showText = true;

  hasField(field: string) {
    if (field === 'wheelchair_accessible_entrance') {
      return !isNullOrUndefined(this.place.wheelchair_accessible_entrance);
    }
    return !isNullOrUndefined(this.place.dine[field]);
  }

  public getFill(field: string) {
    if (field === 'wheelchair_accessible_entrance') {
      if (this.place.wheelchair_accessible_entrance === true) {
        return 'url(#dine-enabled)';
      } else if (this.place.wheelchair_accessible_entrance === false) {
        return 'url(#dine-disabled)';
      }
    }
    if (this.place.dine[field] === true) {
      return 'url(#dine-enabled)';
    } else if (this.place.dine[field] === false) {
      return 'url(#dine-disabled)';
    }
    return '';
  }
}
